import { render, staticRenderFns } from "./integralExchangeRecord.vue?vue&type=template&id=5330f200&scoped=true&"
import script from "./integralExchangeRecord.vue?vue&type=script&lang=js&"
export * from "./integralExchangeRecord.vue?vue&type=script&lang=js&"
import style0 from "./integralExchangeRecord.vue?vue&type=style&index=0&id=5330f200&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330f200",
  null
  
)

export default component.exports